import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { serializeContextData } from "../serializer";
export var AutoMetricApi = /*#__PURE__*/function () {
  function AutoMetricApi() {
    var publishers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, AutoMetricApi);
    this.publishers = publishers;
  }
  _createClass(AutoMetricApi, [{
    key: "publish",
    value: function publish(eventType, node, target) {
      if (!this.publishers.length) {
        console.warn('No publishers attached to AutoMetricApi, event ignored');
        return;
      }
      var context = serializeContextData(node, target);
      this.publishers.forEach(function (publisher) {
        publisher.handleEvent(eventType, context, target);
      });
    }
  }]);
  return AutoMetricApi;
}();